import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import { useSelector } from 'react-redux';
import { AdminCenterIcon } from 'features/left_navigation/icons';
import { isAdminOrOwnerSelector } from 'selectors/current_user';
const bannerWrapperCss = "b1ik5heg";
const styledBannerContainerCss = "sznareg";
const textCss = "t1hutdqk";
export const AdminDisabledNotetakerBanner = ({
  adminDisabledNotetaker
}) => {
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector);
  const adminKillswitchPageRoute = '/app/admin/notetaker/access';
  if (!adminDisabledNotetaker) return null;
  return <div className={bannerWrapperCss}>
      <div className={styledBannerContainerCss}>
        <ContextualBanner icon={AdminCenterIcon} variant="standard">
          <span className={textCss}>
            {isAdminOrOwner ? HtmlParser(I18n.t('publisher.personal_settings.meeting_recaps.admin_disabled_notetaker_banner_for_admins', {
            url: adminKillswitchPageRoute
          })) : I18n.t('publisher.personal_settings.meeting_recaps.admin_disabled_notetaker_banner')}
          </span>
        </ContextualBanner>
      </div>
    </div>;
};

require("./admin_disabled_notetaker_banner.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./admin_disabled_notetaker_banner.js");